<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5 notfound">
      <div class="container pagenot-found">
        <h1 class="mb-4 text-black">404, {{ $t("something_went_wrong") }}...</h1>
        <p class="page-tagline border-bottom border-black border-2 fs-5 pb-4">404- {{ $t("page_not_found") }}</p>
        <b-link :to="{ name: 'home' }" class="btn btn-primary btn-big mx-auto mx-lg-0 not-foud-page">{{
          $t("back_to_homepage") }}</b-link>
        <div class="fs-5 my-5 pt-4">
          <cmsBlockSimple v-if="typeof CMSBlock == 'object'" :identifier="CMSBlock.identifier" class="block-wrapper" />
          <!-- <h2 class="h3 text-black mb-3">{{ $t("404_text_1") }}</h2>
          <div class="collapse collapse-read-more collapse-mobile" id="collapse-read-more-1" style="--height:150">
            404_text_2
            <p class="mb-4">{{ $t("404_text_2") }}</p>
          </div>
          <a class="collapse-read-more-toggle" data-toggle="collapse" href="#collapse-read-more-1" role="button"
            aria-expanded="false" aria-controls="collapse-read-more-1">lees</a> -->
        </div>
        <div class="offers my-5 pt-5" v-if="inActionProducts && inActionProducts.length > 0">
          <h2 class="section-heading"><span>{{ $t("offers") }}</span></h2>
          <ClientOnly>
            <div class="product-grid">
              <div class="swiper">
                <div class="grid-row row row-cols-2 row-cols-lg-3 row-cols-xl-4 swiper-wrapper">
                  <div class="col swiper-slide" v-for="(product, index) of inActionProducts" :key="`prod` + index">
                    <ProductCardWithPagination :product="product" v-if="product != null" />
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev swiper-nav-round offers-swiper-button-prev"></div>
              <div class="swiper-button-next swiper-nav-round offers-swiper-button-next"></div>
              <div class="d-flex justify-content-between align-items-center my-5 d-lg-none">
                <p class="fs-6 mb-0">{{ $t("articles") }} {{ paginationConf.currentPageNr }} {{ $t("to") }} {{
                  Math.ceil(rows / paginationConf.perPage) }} {{ $t("by") }} {{ rows }} in {{ $t("total") }}</p>
                <b-pagination v-model="paginationConf.currentPageNr" :total-rows="rows"
                  :per-page="paginationConf.perPage" @change="tmp" class="cst-pagination ms-4 mt-3"
                  aria-controls="cat-item" align="right" :hide-goto-end-buttons="true">
                  <template #page="{ page }">
                    <b-link class="page-link">
                      {{ page }}
                    </b-link>
                  </template>
                </b-pagination>
              </div>
            </div>
          </ClientOnly>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import ProductCardWithPagination from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCardWithPagination.vue";
import ClientOnly from "vue-client-only";
import { isMobile } from "mobile-device-detect";
import cmsBlockSimple from "@/base/core/components/common/BlockSimple.vue";


export default {
  name: "pageNotFound",
  components: {
    Breadcrumbs,
    ProductCardWithPagination,
    ClientOnly,
    cmsBlockSimple,
  },
  mounted() {
    const bcrumb = { current: "404", routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
  },
  computed: {
    CMSBlock() {
      return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`]("404_page_not_found");
    },
    inActionProducts() {
      const items = this.$store.getters["home/getInActionProducts"];
      if (items.length === 0) {
        return [];
      }
      if (isMobile) {
        return items.slice(
          (this.paginationConf.currentPageNr - 1) * this.paginationConf.perPage,
          this.paginationConf.currentPageNr * this.paginationConf.perPage
        );
      } else {
        return items;
      }
    },
    rows() {
      return this.$store.getters["home/getInActionProducts"].length;
    }
  },
  data() {
    return {
      showOrders: true,
      paginationConf: {
        currentPageNr: 1,
        totalCount: 0,
        perPage: 4,
      }
    }
  },
  methods: {
    tmp(id) {
      this.showOrders = false;
      setTimeout(() => {
        this.showOrders = true;
        this.paginationConf.currentPageNr = id;
      }, 0.001);
    }
  }
};

</script>